import { DefaultService } from '@/services/DefaultService';

export default class TipoRecomendacaoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    updateSituacao(tipoRecomendacao) {
        return this._http
            .post(
                `${this._env}/agro-visita/agro-tiporecomendacao/updatesituacao`,
                tipoRecomendacao,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    findAll(column, order, page, limit, situacao, ...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/agro-visita/agro-tiporecomendacao.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    findAllCombo(...params) {
        return this._http
            .get(
                encodeURI(
                    `${this._env}/agro-visita/agro-tiporecomendacao/getcombo.json?param=${params}`
                ),
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    find(id) {
        return this._http
            .get(`${this._env}/agro-visita/agro-tiporecomendacao/${id}.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error('Problems while jobs are loading');
                }
            );
    }

    save(form) {
        return this._http
            .post(`${this._env}/agro-visita/agro-tiporecomendacao`, form, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }
}
